// src/api/publicApi.js

const BASE_URL = "https://www.emsifa.com/api-wilayah-indonesia/api";

/**
 * Mengambil daftar seluruh Provinsi di Indonesia
 */
export const getProvinces = async () => {
  try {
    const response = await fetch(`${BASE_URL}/provinces.json`);
    if (!response.ok) throw new Error("Gagal mengambil data provinsi");
    return await response.json();
  } catch (error) {
    console.error("Error Provinces:", error);
    return [];
  }
};

/**
 * Mengambil daftar Kota/Kabupaten berdasarkan ID Provinsi
 * @param {string} provinceId 
 */
export const getRegencies = async (provinceId) => {
  if (!provinceId) return [];
  try {
    const response = await fetch(`${BASE_URL}/regencies/${provinceId}.json`);
    if (!response.ok) throw new Error("Gagal mengambil data kota");
    return await response.json();
  } catch (error) {
    console.error("Error Regencies:", error);
    return [];
  }
};